import * as React from 'react';

import Loom from './Loom';
import NativeVideo from './NativeVideo';
import Supademo from './Supademo';
import Typeform from './Typeform';
import Vimeo from './Vimeo';
import Wistia from './Wistia';
import Youtube from './Youtube';

export type EmbedProps = {
  attrs: {
    href: string;
  };
  isAttachmentVideo?: boolean;
};

interface IEmbedComponent extends React.FC<EmbedProps> {
  isMatch: (href: string) => boolean | Promise<boolean>;
}

const syncEmbedComponents: IEmbedComponent[] = [Loom, Supademo, Typeform, Youtube, Wistia, Vimeo, NativeVideo];

const useMatchedComponent = (href: string, components: IEmbedComponent[]) => {
  return React.useMemo(() => {
    try {
      const match = components.find((Embed) => Embed.isMatch(href));

      return match ? { Component: match } : null;
    } catch (error) {
      console.error('Error finding embed match:', error);

      return null;
    }
  }, [href, components]);
};

const EmbedComponent: React.FC<EmbedProps> = (props) => {
  const { href } = props.attrs;
  const { isAttachmentVideo } = props;
  const matched = useMatchedComponent(href, syncEmbedComponents);

  // Skip checking for all possible embedding if `href` is proven a video attachment
  if (isAttachmentVideo) {
    return <NativeVideo {...props} />;
  }

  if (matched) {
    const { Component } = matched;

    return <Component {...props} />;
  }

  return null;
};

export default EmbedComponent;
